const DUPLICATE_SUFFIX_REGEX = /\s\(\d+\)$/;

/**
 * Extract the last path segment from a full storage path.
 */
export const getFileNameFromPath = (path = '') => {
  const normalized = typeof path === 'string' ? path.trim() : '';
  if (!normalized) return '';

  const pathParts = normalized.split('/').filter(Boolean);
  return pathParts[pathParts.length - 1] || '';
};

/**
 * Remove duplicate-style numeric suffixes from file names.
 * Example: "invoice (2).pdf" -> "invoice.pdf"
 */
export const stripNumericDuplicateSuffix = (fileName = '') => {
  const normalized = typeof fileName === 'string' ? fileName.trim() : '';
  if (!normalized) return '';

  const extensionSeparator = normalized.lastIndexOf('.');
  const hasExtension = extensionSeparator > 0;

  const baseName = hasExtension
    ? normalized.slice(0, extensionSeparator)
    : normalized;
  const extension = hasExtension
    ? normalized.slice(extensionSeparator)
    : '';

  const cleanBaseName = baseName.replace(DUPLICATE_SUFFIX_REGEX, '');
  return cleanBaseName ? `${cleanBaseName}${extension}` : normalized;
};

/**
 * Convert a file name or path into a user-facing display name.
 */
export const getDocumentDisplayName = (fileNameOrPath = '') => {
  const fileName = getFileNameFromPath(fileNameOrPath);
  if (!fileName) return '';
  return stripNumericDuplicateSuffix(fileName);
};

